import ContractStatements from './ContractStatements';

export default ContractStatements;
